// Phone header controls from _AuthenticatedLayout.cshtml: the ☰ button opens the sidebar as a drawer under the
// header, and the avatar opens the account menu. Opening one closes the other. Loaded on every page via global.ts.

function initHeaderMenus(header: HTMLElement) {
    var navToggle = header.querySelector<HTMLButtonElement>("[data-nav-toggle]");
    var sidebar = document.getElementById("app-sidebar");
    var userMenu = header.querySelector<HTMLElement>("[data-user-menu]")!;
    var userButton = userMenu.querySelector<HTMLButtonElement>(".user-menu-button")!;
    var userPanel = userMenu.querySelector<HTMLElement>(".user-menu-panel")!;

    function isNavOpen(): boolean {
        return document.documentElement.classList.contains("nav-drawer-open");
    }

    function setNavOpen(open: boolean) {
        if (!navToggle || !sidebar) {
            return;
        }
        if (open) {
            setUserMenuOpen(false);
            // The drawer covers everything below the header, wherever the page happens to be scrolled.
            sidebar.style.top = Math.max(0, header.getBoundingClientRect().bottom) + "px";
        }
        else {
            sidebar.style.top = "";
        }
        document.documentElement.classList.toggle("nav-drawer-open", open);
        navToggle.setAttribute("aria-expanded", open ? "true" : "false");
        navToggle.textContent = open ? "✕" : "☰";
    }

    function setUserMenuOpen(open: boolean) {
        if (open) {
            setNavOpen(false);
        }
        userPanel.hidden = !open;
        userButton.setAttribute("aria-expanded", open ? "true" : "false");
    }

    if (navToggle) {
        navToggle.addEventListener("click", function () {
            setNavOpen(!isNavOpen());
        });
    }

    userButton.addEventListener("click", function () {
        setUserMenuOpen(userPanel.hidden);
    });

    document.addEventListener("click", function (e) {
        if (!userPanel.hidden && !userMenu.contains(e.target as Node)) {
            setUserMenuOpen(false);
        }
    });

    document.addEventListener("keydown", function (e) {
        if (e.key !== "Escape") {
            return;
        }
        if (!userPanel.hidden) {
            setUserMenuOpen(false);
            userButton.focus();
        }
        if (navToggle && isNavOpen()) {
            setNavOpen(false);
            navToggle.focus();
        }
    });

    // Past the phone breakpoint ($breakpoint-md) the sidebar is back in the page, so drop the drawer and menu.
    window.matchMedia("(min-width: 768px)").addEventListener("change", function (e) {
        if (e.matches) {
            setNavOpen(false);
            setUserMenuOpen(false);
        }
    });

    // Going back to a page restored from the back/forward cache would otherwise show the drawer still open
    // over it, since tapping a drawer link is how the user left.
    window.addEventListener("pageshow", function (e) {
        if (e.persisted) {
            setNavOpen(false);
            setUserMenuOpen(false);
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    var header = document.querySelector<HTMLElement>(".authenticated-header");
    if (header) {
        initHeaderMenus(header);
    }
});

export {};
